import { getErrorHandler } from '@office-start/error-handler';
import { KnownInstrumentationEvents, } from '@office-start/instrumentation-types';
import { getRequestIdFromResponse, httpGet } from '@office-start/xhr-service';
import { getGraphServiceEndpoint } from '../utilities/getGraphServiceEndpoint';
//this endpoint will return user OneDrive id
var myDriveIdEndpoint = 'me/drive';
export function getMyDriveInfo(graphXhrOptions, inMockMode) {
    var url = getGraphServiceEndpoint(graphXhrOptions.graphApiRoot, myDriveIdEndpoint, false);
    var requestConfig = {
        method: "GET" /* HttpRequestMethod.Get */,
    };
    if (inMockMode) {
        return Promise.resolve({ driveId: '', driveUrl: '' });
    }
    return httpGet(KnownInstrumentationEvents.OneDriveGraphMyDriveInfoRequest, "OneDrive_Graph_MyDriveInfo" /* KnownRequestInstrumentationEvents.OneDriveGraphMyDriveInfoRequest */, url, requestConfig, graphXhrOptions.jwtAuthEnabled, graphXhrOptions.getAccessToken, graphXhrOptions.officeApiRoot, graphXhrOptions.correlationId, 'Graph', {
        populateRequestEvent: function (response, params) {
            params["RequestId" /* InstrumentationParam.RequestId */] =
                getRequestIdFromResponse(response) || '';
        },
    })
        .then(function (response) {
        var rootItem = response.data;
        var driveId = rootItem ? rootItem.id : '';
        var driveUrl = rootItem ? rootItem.webUrl : '';
        // Drive URL only exists in commercial
        if (!driveId) {
            // TODO: Log Error
            return null;
        }
        return { driveId: driveId, driveUrl: driveUrl };
    })
        .catch(function (error) {
        getErrorHandler().handleError(error, "m01Uz" /* ErrorId.m01Uz */);
        return null;
    });
}
//# sourceMappingURL=getMyDriveInfo.js.map